import { Flex, Image, HStack, Box } from '@chakra-ui/react';
import naptinlogo from '../img/naptinlogo.png';
import trainer from '../img/trainer.svg';

const ForgotPasswordLayout = (props: any) => {

    return (
        <Flex minHeight="100vh" >

            <HStack alignItems="center" width="100%" spacing={20}>
                <Box width={{ base: "0%", md: "20%", lg: "50%", xl: "100%" }}>
                    <Image src={trainer} width="100%" height='95vh' />
                </Box>
                <Flex direction="column" bg="white" height="100vh" justifyContent="center" width="100%" >

                    <Box pl={{ base: "5em", lg: "10em", xl: "10em" }} mb={6}>
                        <Image src={naptinlogo} width="8rem" />
                    </Box>

                    <Box pl={{ base: "5em", lg: "10em", xl: "10em" }} pr={{ base: "0em", lg: "8em", xl: "8em" }} mt={10}>
                        {props.children}
                    </Box>

                </Flex>



            </HStack>

        </Flex>
    );
}

export default ForgotPasswordLayout;